import {AgGridVue} from "ag-grid-vue";
import "@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss";
import vSelect from "vue-select";
import moduleOptimization from "@/store/optimization/moduleOptimization.js";
import moduleOptimizationGroup from "@/store/optimization-group/moduleOptimizationGroup.js";
import CellRendererStatus from "@/components/optimization/cell-renderer/CellRendererStatus.vue";
import CellRendererActions from "@/components/optimization/cell-renderer/CellRendererActions.vue";
import CellRendererTypeRouting from "@/components/optimization/cell-renderer/CellRendererTypeRouting.vue";
import {EventBus} from "@/helpers/eventBus.js";

export const OptimizationListMixin = {
	name: "OptimizationList",
	props: {
		statusOptimization: {
			type: String,
			default: "All",
		},
		showInPopup: {
			type: Boolean,
			default: false,
		},
	},
	components: {
		AgGridVue,
		vSelect,
		CellRendererStatus,
		CellRendererActions,
		CellRendererTypeRouting,
	},
	data() {
		return {
			searchQuery: [],
			currentPageLocal: 1,
			quantityElementPage: 12,
			searchField: "Name",
			gridApi: null,
			gridOptions: {},
			isExactly: false,
			infoSelected: null,
			arrayInfo: [],
			pagination: {
				next_page: 0,
				total_pages: 0,
				total_records: 0,
			},
			defaultColDef: {
				sortable: true,
				resizable: true,
				suppressMenu: true,
				flex: 1,
			},
			components: {
				CellRendererStatus,
				CellRendererActions,
				CellRendererTypeRouting,
			},
		};
	},
	watch: {
		currentPageLocal(page) {
			EventBus.$off();
			this.getOptimization(page);
		},
		quantityElementPage() {
			this.getOptimization(1);
		},
		searchField(val) {
			this.infoSelected = null;
			if (val === "RoutingTypeSearch") {
				const Options = [
					{
						name: "OPENROUTE",
						id: "OPENROUTE",
					},
					{
						name: "GMPRO",
						id: "GMPRO",
					},
					{
						name: "TOURPLANNING",
						id: "TOUR_PLANNING",
					},
				];
				this.getData(Options);
			} else if (val === "OptimizationGroup") {
				this.$store.dispatch("moduleOptimizationGroup/findAll").then((res) => {
					this.getData(res.data);
				});
			} else if (val === "State") {
				const Options = [
					{
						name: this.$t("FINALIZED"),
						id: "FINALIZED",
					},
					{
						name: this.$t("PROCESSING"),
						id: "PROCESSING",
					},
					{
						name: this.$t("ERROR"),
						id: "ERROR",
					},
				];
				this.getData(Options);
			}
		},
	},
	created() {
		if (!moduleOptimization.isRegistered) {
			this.$store.registerModule("moduleOptimization", moduleOptimization);
			moduleOptimization.isRegistered = true;
		}
		if (!moduleOptimizationGroup.isRegistered) {
			this.$store.registerModule("moduleOptimizationGroup", moduleOptimizationGroup);
			moduleOptimizationGroup.isRegistered = true;
		}
	},
	async mounted() {
		this.gridApi = this.gridOptions.api;
		if (this.$vs.rtl) {
			const header = this.$refs.agGridTable.$el.querySelector(".ag-header-container");
			header.style.left = `-${String(Number(header.style.transform.slice(11, -3)) + 9)}px`;
		}
		EventBus.$on("listDocuments", (value) => {
			if (value.event === "OPTIMIZATION_DONE") {
				const found = this.optimizationData.find(
					(optimization) => optimization.id === value.body.optimization_id
				);
				if (found) {
					this.refreshTable(this.currentPageLocal);
				}
			}
			if (value.event === "OPTIMIZATION_ERROR") {
				const found = this.optimizationData.find(
					(optimization) => optimization.id === value.body.optimization_id
				);
				if (found) {
					this.refreshTable(this.currentPageLocal);
				}
			}
		});
		const matchFilter = await this.$store.dispatch("moduleMatchFilter/getMatchFilter");
		if (Object.entries(matchFilter) > 0) {
			this.isExactly = matchFilter.filter_exact_optimization;
		} else {
			this.isExactly = this.$store.state.moduleMatchFilter.filter_exact_optimization;
		}
		this.getOptimization(1);
	},
	computed: {
		isWidthPortatil() {
			return window.innerWidth <= 1366;
		},
		windowWidth() {
			return this.$store.state.windowWidth;
		},
		overlayLoadingTemplate() {
			return `<div class="ring">${this.$t("Loading")}<span></span></div>`;
		},
		overlayNoRowsTemplate() {
			return `<span style="font-size: 14px; font-weight: 500; color: grey">${this.$t("NoDataAvailable")}</span>`;
		},
		columnDefs() {
			let filterHead = undefined;
			let columns = [
				{
					headerName: "ID",
					field: "id",
					width: 100,
					filter: filterHead,
					headerCheckboxSelectionFilteredOnly: true,
					cellRendererFramework: null,
				},
				{
					headerName: this.$t("Routing.Table.Name"),
					field: "name",
					filter: filterHead,
					width: 350,
				},
				{
					headerName: this.$t("RoutingType.RoutingType"),
					field: "routing_api",
					filter: filterHead,
					width: 300,
					cellRendererFramework: "CellRendererTypeRouting",
				},
				{
					headerName: this.$t("TypeConfig.Form.Status"),
					field: "status",
					filter: filterHead,
					width: 300,
					cellRendererFramework: "CellRendererStatus",
				},
				{
					headerName: this.$t("Group.Group"),
					field: "optimization_group_name",
					filter: filterHead,
					width: 300,
				},
				{
					headerName: this.$t("Routing.Table.AddedOn"),
					field: "added_on",
					filter: filterHead,
					width: 300,
				},
			];
			if (!this.showInPopup) {
				columns.push({
					headerName: this.$t("ResourceModule.Table.Actions"),
					field: "transactions",
					width: 150,
					cellRendererFramework: "CellRendererActions",
					pinned: "right",
				});
			}
			const showColumns = [];
			if (showColumns.length > 0) {
				columns = columns.filter((column) => {
					if (showColumns.includes(column.field)) {
						return column;
					}
				});
			}
			return columns;
		},
		paginationPageSize() {
			if (this.pagination.total_records > 0) {
				return this.pagination.total_records;
			} else {
				return 0;
			}
		},
		totalPages() {
			if (this.pagination.total_pages > 0) return this.pagination.total_pages;
			else return 0;
		},
		currentPage: {
			get() {
				return this.currentPageLocal;
			},
			set(val) {
				this.currentPageLocal = val;
			},
		},
		searchSelected() {
			return this.$t(`${this.searchField}`);
		},
		searchFieldSelected() {
			if (this.searchField === "RoutingTypeSearch") return "RoutingTypeSearch";
			else if (this.searchField === "OptimizationGroup") return "OptimizationGroup";
			else if (this.searchField === "State") return "State";
		},
		optimizationData() {
			return this.$store.state.moduleOptimization.optimizationList === undefined ||
				this.$store.state.moduleOptimization.optimizationList === "" ||
				this.$store.state.moduleOptimization.optimizationList === null
				? []
				: this.$store.state.moduleOptimization.optimizationList;
		},
	},
	methods: {
		getOptimization(page) {
			this.onBtShowLoading();
			const payload = {
				sort: "desc",
				page,
				quantity: this.quantityElementPage,
				status: this.showInPopup && this.statusOptimization != "All" ? [this.statusOptimization] : [],
				match_filter: !this.isExactly,
				order_by: ["id"],
			};
			this.$store
				.dispatch("moduleOptimization/optimizationFilter", payload)
				.then((res) => {
					Object.assign(this.pagination, res.pagination);
					setTimeout(() => {
						this.resetColFilters();
					}, 100);
					this.onBtHide();
				})
				.catch((err) => {
					this.onBtHide();
					console.error(err);
				});
		},
		refreshTable(page) {
			const payload = {
				sort: "desc",
				page,
				quantity: this.quantityElementPage,
				status_id: this.status_id,
				match_filter: !this.isExactly,
				order_by: ["id"],
			};
			this.$store
				.dispatch("moduleOptimization/optimizationFilter", payload)
				.then((res) => {
					Object.assign(this.pagination, res.pagination);
					setTimeout(() => {
						this.resetColFilters();
					}, 100);
				})
				.catch((err) => {
					console.error(err);
				});
		},
		setColumnFilter(column, val) {
			const filter = this.gridApi.getFilterInstance(column);
			let modelObj = null;
			if (val !== "all") {
				modelObj = {type: "equals", filter: val};
			}
			filter.setModel(modelObj);
			this.gridApi.onFilterChanged();
		},
		resetColFilters() {
			this.gridApi.setFilterModel(null);
			this.gridApi.onFilterChanged();
		},
		updateSearchQuery(val) {
			this.gridApi.setQuickFilter(val);
		},
		search() {
			const searchQueryList = this.searchQuery.map(({value}) => {
				if (this.searchField === "Id") return parseInt(value);
				return value;
			});
			const dataPage = {
				id: this.searchField === "Id" ? searchQueryList : [],
				name: this.searchField === "Name" ? searchQueryList : [],
				routing_api: this.searchField === "RoutingTypeSearch" ? this.infoSelected.map(({value}) => value) : [],
				optimization_group_id:
					this.searchField === "OptimizationGroup" ? this.infoSelected.map(({value}) => value) : [],
				status: (() => {
					if (this.searchField === "State") {
						return this.infoSelected.flatMap(({value}) =>
							value === "ERROR" ? ["ERROR", "CREATED"] : [value]
						);
					} else if (this.showInPopup && this.statusOptimization != "All") {
						return [this.statusOptimization];
					}
					return [];
				})(),
				match_filter: !this.isExactly,
				order_by: ["id"],
				sort: "desc",
			};
			this.onBtShowLoading();
			this.$store
				.dispatch("moduleOptimization/optimizationFilter", dataPage)
				.then((res) => {
					Object.assign(this.pagination, res.pagination);
					setTimeout(() => {
						this.resetColFilters();
					}, 100);
					this.onBtHide();
				})
				.catch((err) => {
					this.onBtHide();
					console.error(err);
				});
		},
		generateOptionSelect(data, propLabel, propValue) {
			return data.map((d) => {
				return {label: d[propLabel], value: d[propValue]};
			});
		},
		paginationSetPageSize(num) {
			this.gridApi.paginationSetPageSize(num);
			this.quantityElementPage = num;
		},
		refresh() {
			this.searchQuery = [];
			this.infoSelected = null;
			this.getOptimization(1);
		},
		setSearchField(val) {
			this.searchField = val;
		},
		onBtShowLoading() {
			this.gridApi.showLoadingOverlay();
		},
		onBtHide() {
			this.gridApi.hideOverlay();
		},
		openEnableConfirm(val) {
			if (val) {
				this.$vs.dialog({
					type: "confirm",
					color: "primary",
					title: this.$t("Confirm"),
					text: `${this.$t("Preferences.FilterSearchExactText")}`,
					accept: () => {
						this.isExactly = val;
						this.updateMatchFilter();
					},
					cancel: () => {
						this.isExactly = false;
					},
					acceptText: this.$t("Accept"),
					cancelText: this.$t("Cancel"),
				});
			} else {
				this.isExactly = val;
				this.updateMatchFilter();
			}
		},
		async updateMatchFilter() {
			const payload = {};
			payload["filter_exact_optimization"] = this.isExactly;
			try {
				await this.$store.dispatch("moduleMatchFilter/updateMatchFilter", payload);
			} catch (error) {
				this.$vs.notify({
					color: "danger",
					title: this.$t("ErrorTitle"),
					text: this.$t("ErrorMessage"),
				});
			}
		},
		getData(data) {
			this.arrayInfo = data.map((info) => {
				return {label: info.name, value: info.id};
			});
		},
	},
	beforeDestroy() {
		this.$store.commit("moduleOptimization/REMOVE_ALL_OPTIMIZATION");
	},
};
